import { RootState } from "store";

export const sidebarSelector = (state: RootState) => state.sidebar.opened;
